import React, { createContext, useContext, ReactNode , useState} from 'react';
import { usePreviousPath } from './PreviousPathContext';

interface DataLayerProps {
  'page_type': string | undefined,
  'locale': string | undefined,
  'environment': string | undefined,
  'sessionId': string | undefined,
  'fa_no': string | undefined,
  'fa_entity_id': string | undefined
}

interface DataLayerContextType {
  dataLayerInfo : DataLayerProps;
  setDataLayerInfo: React.Dispatch<React.SetStateAction<DataLayerProps>>;
}

const DataLayerContext = createContext<DataLayerContextType | undefined>(undefined);
export const DataLayerInfoProvider: React.FC<{ children: ReactNode }>=({ children }) => {
  const [dataLayerInfo, setDataLayerInfo] = useState<DataLayerProps>({
    'page_type': 'welcome-page',
    'locale': undefined,
    'environment': window.ENVIRONMENT,
    'sessionId': undefined,
    'fa_no': undefined,
    'fa_entity_id': undefined
  });
  const previousPath = usePreviousPath().previousPath;

  return (<DataLayerContext.Provider value={{ dataLayerInfo, setDataLayerInfo }}>
      {children}
    </DataLayerContext.Provider>
  );
};
export const useDataLayerInfo = (): DataLayerContextType => {
  const context = useContext(DataLayerContext);
  if(!context) {
    throw new Error('unsafe use of provider');
  }
  return context;
}